<template>
	<span class="time text-color">{{ TimerStr }}</span>
</template>

<script>
export default {
	name: "Timer"
	,data: () => ({
		Timer: null,
		TimeCounter: 179,
		TimerStr: "02:59",
		interval:null,
	}),
	mounted() {
		//문자발송성공시 호출
		if(this.Timer != null){
			this.timerStop(this.Timer);
			this.Timer = null;
		}
	},
	methods : {
    timerStart () {
      this.TimeCounter = 179;
      let interval = setInterval(() => {
        if (this.TimeCounter <= 0) {
          this.timerStop(interval);
          this.TimeCounter = 0;
          this.TimerStr = this.prettyTime();
          return;
        }
        this.TimeCounter--; // 1초씩 감소
        this.TimerStr = this.prettyTime();
      }, 1000);
      this.interval = interval;
      return interval;
    },
		timerStop (Timer) {
			clearInterval(Timer);
			//this.TimeCounter = 0;
			this.TimerStr = this.prettyTime(); //마지막 타임을 고정 텍스트로 지정하여 스탑 처리 하기.
			clearInterval(this.interval);
		},
    prettyTime () {
      let counter = Math.max(this.TimeCounter, 0); // 음수 방지
      let minutes = Math.floor(counter / 60);
      let secondes = counter % 60;
      return (
          minutes.toString().padStart(2, "0") +
          ":" +
          secondes.toString().padStart(2, "0")
      );
    }
	},
	watch: {
		TimeCounter () {
			if(this.TimeCounter===0) {
				this.$alert("인증번호 입력 시간이 지났습니다.<br />다시 진행해주세요");
				clearInterval(this.Timer);
				this.$emit('timeOver')
				return false;
			}
		},
	}

}
</script>

<style scoped>
	.text-color {
		color:#FF4A4A;
	}
</style>
